// @ts-check
import React from "react"

/**
 * @param {import("./TableBodyEmpty.component.types").TableBodyEmptyProps} props
 */
export const TableBodyEmpty = (props) => {
  const { table, emptyMessage } = props

  return (
    <tbody className="table__body table__body--empty">
      <tr className="table__body-row table__body-row--empty">
        <td colSpan={table.getVisibleLeafColumns().length}>{emptyMessage}</td>
      </tr>
    </tbody>
  )
}
